import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { UnloadingInfo } from './types';

type GetUnloadingListArgs = {
  porSlot: boolean;
  codViaje: number;
};

type GetUnloadingListResponse = {
  state: number;
  value: UnloadingInfo[];
};

export const getUnloadingList = async ({
  porSlot,
  codViaje,
}: GetUnloadingListArgs): Promise<UnloadingInfo[]> => {
  try {
    const res = await apiClient.post<GetUnloadingListResponse>(
      Endpoints.UnloadingList,
      {
        porSlot,
        codViaje,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
